import React from 'react';
import { Link } from 'react-router-dom';

// Translation
import translate from '../translate/Translate';

// Icons
import * as icons from '../ui/Icons';

const Pagination = class Pagination extends React.Component {
  handleClick = value => {
    const { activePageIndex, onClick } = this.props;

    if (onClick) {
      const newPageIndex = activePageIndex + value;

      onClick(newPageIndex);
    }
  };

  render() {
    const {
      className,
      hideText,
      nextText,
      nextUrl,
      previousText,
      previousUrl,
      title,
      translation
    } = this.props;

    const PrevTag = previousUrl ? Link : 'span';
    const NextTag = nextUrl ? Link : 'span';

    return (
      <nav className={`pagination ${className || ''}`} aria-labelledby="nav-label">
        <h2 className="meta" id="nav-label">{title || translation.heading}</h2>

        <ol className="pagination__list">
          <li className="pagination__prev">
            <PrevTag
              className={`btn${!previousUrl ? ' btn--disabled' : ''}`}
              onClick={previousUrl ? () => this.handleClick(-1) : null}
              to={`${previousUrl}${window.location.search}`}
            >
              <i className={hideText ? 'icon--solo' : 'icon--before'}>
                <icons.chevronLeft />
              </i>

              <span className={hideText ? 'meta' : ''}>
                {previousText || translation.previous}
              </span>
            </PrevTag>
          </li>
          <li className="pagination__next">
            <NextTag
              className={`btn${!nextUrl ? ' btn--disabled' : ''}`}
              onClick={nextUrl ? () => this.handleClick(1) : null}
              to={`${nextUrl}${window.location.search}`}
            >
              <span className={hideText ? 'meta' : ''}>
                {nextText || translation.next}
              </span>

              <i className={hideText ? 'icon--solo' : 'icon--after'}>
                <icons.chevronRight />
              </i>
            </NextTag>
          </li>
        </ol>
      </nav>
    );
  }
};

export default translate('Pagination')(Pagination);
